import { EngineOffIcon } from './EngineOffIcon';

/**
 * author: Michael Irigoyen
 * id 114C29E0-B66E-49EF-8D45-77FF8EED43B1
 * name engine-off
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/engine-off.svg
 * tags
 * - Automotive 
 */
export const MotorOffIcon = EngineOffIcon;
export default MotorOffIcon